import {Api, apiFetch} from "../_helpers/api";
import {to_url, createQueryParameters} from "../_helpers/utils";
import {StyleState} from "../_definitions/styleteq";
import User from "../_data/models/User";
declare const fetch;

const StyleRepository = {
    get: (offsetId: number = null) => {
        return fetch(to_url(Api.apiBaseUrl, 'styles'), {
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
            },
        }).then(response => {
            return response.json();
        });
    },

    getById: (id: number = null) => {
        return fetch(to_url(Api.apiBaseUrl, 'styles/' + id), {
            credentials: "same-origin",
            headers: {
                "Accept": "application/json"
            },
        }).then(response => {
            if (response.ok) {
                return response.json();
            } else {
                return null;
            }
        });
    },

    getByUserId: (user: User, cursor: number = null, page: number = null, perPage: number = 10) => {        
        const query = createQueryParameters({page: page, per_page: perPage});
        return apiFetch(to_url(Api.apiBaseUrl, `users/${user.id}/styles`) + query).
            then(response => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    return {
                        error: true,
                        response: response
                    };
                }
            });
    }

};

export default StyleRepository;


// WEBPACK FOOTER //
// ./app/client/_repositories/styleRepository.ts